<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin]
};

</script>

<template>
  <div class="position-relative" :style="theme" :v-easyadmin="easyadminId" tile-instagram-component>
    <a :href="content.permalink" target="_blank">
      <img :src="content.thumbnail_url || content.media_url" :alt="content.id" class="w-100">
      <div class="caption position-absolute-center p-3 d-flex align-items-center">
        <div>{{content.caption}}</div>
      </div>
    </a>
  </div>
</template>
<style lang="scss">
[tile-instagram-component] {
  .caption {
    opacity: 0;
    background-color: var(--theme-background) !important;
    color: var(--theme-color) !important;
    transition: opacity $animation-time-fast;

    > div {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
  }

  a:hover .caption {
    opacity: 1;
  }

  img {
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
}
</style>